<div class="navigation-items action-items navigation-border-right" *ngIf="!showParicipantsAssignmentNavigation">
  <div class="action-icon" (click)="setSearchBarVisibility()" [class.disabled]="formOpened">
    <svg-icon src='./assets/icons/search-outline.svg' alt="SEARCH" title="{{'projectToolbar.search' | translate | uppercase}}" class="menu-action-icon svg-icon-gray"
              align='center'></svg-icon>
    <div class="icon-label">{{'projectToolbar.search' | translate | uppercase}}</div>
  </div>
  <div *ngIf="searchTabVisible" class="action-icon" (click)="triggerAction('resetValuationSearchMode')">
    <svg-icon src='./assets/icons/showAll.svg' class="menu-action-icon svg-icon-gray"
              title="{{'projectToolbar.showAll' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label" [innerHTML]="'projectToolbar.showAll' | translate | uppercase"></div>
  </div>
  <div class="action-icon"
       (click)="infoBarVisibilityClicked()" [class.disabled]="formOpened">
    <svg-icon src='./assets/icons/searchInfoMode_please_rotate_accordingly.svg' class="menu-action-icon svg-icon-gray"
              title="{{'projectToolbar.buttonInfoMode' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label" [innerHTML]="'projectToolbar.buttonInfoMode' | translate | uppercase"></div>
  </div>
  <div *ngIf="isAdminUser" class="action-icon" (click)="triggerAction('newProjectDataFromNav')">
    <svg-icon src="./assets/icons/add_new.svg" align="center" class="menu-action-icon svg-icon-gray" title="NEW VAL EVENT"></svg-icon>
    <div class="icon-label" [innerHTML]="'projectToolbar.buttonNewProject' | translate | uppercase"></div>
  </div>
  <div *ngIf="isAdminUser" class="action-icon" (click)="!formOpened && triggerAction('buttonDeleteProjectstd')" [class.disabled]="formOpened">
    <svg-icon src="./assets/icons/delete.svg" align="center" class="menu-action-icon svg-icon-gray" title="DELETE EVENT"></svg-icon>
    <div class="icon-label" [innerHTML]="'projectToolbar.buttonDeleteProjectstd' | translate | uppercase"></div>
  </div>
</div>
<div class="navigation-items action-items" [ngClass]="displaySaveCancelActions ? 'navigation-border-right' : ''" *ngIf="!showParicipantsAssignmentNavigation">
  <div *ngIf="isAPT" class="action-icon" (click)="!formOpened && openNewTabAndTriggerAction('newValPortfolioFromNav','valuationTabSelect', 'tabValuationPortfolio')" [class.disabled]="formOpened">
    <svg-icon src="./assets/icons/add_new.svg" align="center" class="menu-action-icon svg-icon-gray" title="NEW VAL EVENT"></svg-icon>
    <div class="icon-label" [innerHTML]="'projectToolbar.buttonNewPortfolio' | translate | uppercase"></div>
  </div>
  <div *ngIf="!formOpened && isAPT" class="action-icon" (click)="assignCalculationModelTemplate()">
    <svg-icon src='./assets/icons/albums-outline.svg' align="center" class="menu-action-icon svg-icon-gray" title="{{'projectToolbar.assignCalculationModelTemplate' | translate | uppercase}}"></svg-icon>
    <div class="icon-label" [innerHTML]="'projectToolbar.assignCalculationModelTemplate' | translate | uppercase"></div>
  </div>
  <div *ngIf="!hideParticipantsIcon" class="action-icon" (click)="showParicipantsTemplate()" [class.disabled]="!isParticipantsIconEnabled">
    <svg-icon src='./assets/icons/people-outline.svg' class="menu-action-icon svg-icon-gray"
              title="{{'projectToolbar.participants' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label">{{'projectToolbar.participants' | translate | uppercase}}</div>
  </div>

</div>
<div class="navigation-items action-items" *ngIf="!showParicipantsAssignmentNavigation">
  <div *ngIf="displaySaveCancelActions" class="action-icon" (click)="saveCancelActions('saveProjectData')" [class.disabled]="saveInProgress">
    <svg-icon src='./assets/icons/save.svg' class="menu-action-icon svg-icon-gray"
              title="{{'projectToolbar.save' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label">{{'projectToolbar.save' | translate | uppercase}}</div>
  </div>
  <div *ngIf="displaySaveCancelActions" class="action-icon" (click)="displayFullNavigation()">
    <svg-icon src='./assets/icons/close-outline.svg' class="menu-action-icon svg-icon-gray"
              title="{{'projectToolbar.cancel' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label">{{'projectToolbar.cancel' | translate | uppercase}}</div>
  </div>
</div>
<div class="navigation-items navigation-border-right action-items" *ngIf="showParicipantsAssignmentNavigation">
  <div class="action-icon" [ngClass]="disableCancel ? 'disabled': ''" (click)="closeParticipants();">
    <svg-icon src='./assets/icons/close-outline.svg' class="menu-action-icon svg-icon-gray"
              title="{{'projectToolbar.back' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label">{{'projectToolbar.back' | translate | uppercase}}</div>
  </div>
</div>
<div class="navigation-items action-items" *ngIf="showParicipantsAssignmentNavigation">
  <div class="action-icon" (click)="onSaveProjectParticipants()">
    <svg-icon src='./assets/icons/save.svg' class="menu-action-icon svg-icon-gray"
              title="{{'projectToolbar.save' | translate | uppercase}}" align='center'></svg-icon>
    <div class="icon-label">{{'projectToolbar.save' | translate | uppercase}}</div>
  </div>
</div>
<div class="navigation-items action-items" *ngIf="isAdminUser && !displaySaveCancelActions && !showParicipantsAssignmentNavigation">
  <div class="action-icon" (click)="showProjectsExportPane()">
    <svg-icon src="./assets/icons/download_export.svg" align="center" class="menu-action-icon svg-icon-gray"></svg-icon>
    <div class="icon-label" [innerHTML]="'projectToolbar.buttonExports' | translate | uppercase"></div>
  </div>
</div>
